import React, { useEffect, useState } from 'react';
import TextArea from 'antd/lib/input/TextArea';
import UpdateVersionCommentMutation from '../../../_graphql/mutations/versions/UpdateVersionCommentMutation';
import { errorMessage, successMessage } from '../../../utils/messageMutation';
import { MAX_VERSION_COMMENT_LENGTH } from '../../../_CONST';
import BaseModal from '../../../components/BaseModal';

const ModalEditVersionComment = ({
  visible,
  onHide,
  versionId,
  comment: initialComment
}) => {
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState(initialComment);

  useEffect(() => {
    setComment(initialComment);
  }, [initialComment]);

  const handleCreate = () => {
    setLoading(true);
    UpdateVersionCommentMutation({ versionId, comment }, (ok, error) => {
      setLoading(false);
      if (ok && !error) {
        successMessage('commentaire', 'modifié avec succès', false, false);
        !!onHide && onHide();
      } else {
        errorMessage();
      }
    });
  };

  return (
    <BaseModal
      title="Modification du commentaire"
      visible={visible}
      onHide={onHide}
      disabled={loading}
      onClick={handleCreate}
      loading={loading}
    >
      <TextArea
        className="mb-4"
        placeholder="Commentaire"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        autoSize={{ minRows: 4, maxRows: 6 }}
        maxLength={MAX_VERSION_COMMENT_LENGTH}
      />
    </BaseModal>
  );
};

export default ModalEditVersionComment;
